var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.190002,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 59C52.8043 59 57.8914 56.8929 61.6421 53.1421C65.3929 49.3914 67.5 44.3043 67.5 39C67.5 33.6957 65.3929 28.6086 61.6421 24.8579C57.8914 21.1071 52.8043 19 47.5 19C42.1957 19 37.1086 21.1071 33.3579 24.8579C29.6071 28.6086 27.5 33.6957 27.5 39C27.5 44.3043 29.6071 49.3914 33.3579 53.1421C37.1086 56.8929 42.1957 59 47.5 59ZM47.5 54C43.5218 54 39.7064 52.4196 36.8934 49.6066C34.0804 46.7936 32.5 42.9782 32.5 39C32.5 35.0218 34.0804 31.2064 36.8934 28.3934C39.7064 25.5803 43.5218 24 47.5 24C51.4782 24 55.2936 25.5803 58.1066 28.3934C60.9197 31.2064 62.5 35.0218 62.5 39C62.5 42.9782 60.9197 46.7936 58.1066 49.6066C55.2936 52.4196 51.4782 54 47.5 54ZM45 49H48.75V39.55L54.575 33.725L51.925 31.075L45 38V49ZM15 24C14.337 24 13.7011 24.2634 13.2322 24.7322C12.7634 25.2011 12.5 25.837 12.5 26.5C12.5 27.163 12.7634 27.7989 13.2322 28.2678C13.7011 28.7366 14.337 29 15 29H24.575C25.35 27.225 26.35 25.55 27.5 24H15ZM17.5 36.5C16.837 36.5 16.2011 36.7634 15.7322 37.2322C15.2634 37.7011 15 38.337 15 39C15 39.663 15.2634 40.2989 15.7322 40.7678C16.2011 41.2366 16.837 41.5 17.5 41.5H22.625L22.5 39L22.625 36.5H17.5ZM20 49C19.337 49 18.7011 49.2634 18.2322 49.7322C17.7634 50.2011 17.5 50.837 17.5 51.5C17.5 52.163 17.7634 52.7989 18.2322 53.2678C18.7011 53.7366 19.337 54 20 54H27.5C26.35 52.45 25.35 50.775 24.575 49H20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy1);
export default __webpack_public_path__ + "static/media/why1.882b4b41fbc26cdce20c93818403d177.svg";
export { ForwardRef as ReactComponent };